export { Close as FormModalClose } from '@radix-ui/react-dialog';
export { FormModal } from './FormModal';
export type {
  FormModalHeaderVariant,
  FormModalProps,
  FormModalPropsMicrocopy,
  FormModalSize,
  FormModalVariant,
} from './FormModal.types';
